import Vue from 'vue'
// @ts-expect-error checked
import Vuetify from 'vuetify/lib/framework'
// @ts-expect-error checked
import pl from 'vuetify/es5/locale/pl'

Vue.use(Vuetify)

const template = {
  light: {
    primary: '#8E7356',
    secondary: '#C5A059',
    accent: '#D9B48F',
    darkBlue: '#07182f',
    background: '#FFFFFF',
    neutral: '#1A1A1A',
    surface: '#F4F6F9',
  },
  dark: {
    primary: '#D9B48F',
    secondary: '#C5A059',
    accent: '#E8C9A8',
    darkBlue: '#2d5a8f',
    background: '#07182f',
    neutral: '#E8EDF5',
    surface: '#0f2748',
  },
}

const mq = window.matchMedia('(prefers-color-scheme: dark)')
const dark

  = localStorage.dark === undefined
    ? mq.matches
    : JSON.parse(localStorage.dark)

const vuetify = new Vuetify({
  lang: {
    locales: { pl },
    current: 'pl',
  },
  theme: {
    dark,
    themes: template,
    options: {
      variations: false,
      minifyTheme(css: string) {
        // @ts-expect-error checked
        return import.meta.env.NODE_ENV === 'production'
          ? css.replace(
              /[\r\n|]/g,
              '',
            )
          : css
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
})

vuetify.framework.theme.dark

  = localStorage.dark === undefined
    ? mq.matches
    : JSON.parse(localStorage.dark)
mq.addListener((event) => {
  vuetify.framework.theme.dark

    = localStorage.dark === undefined
      ? event.matches
      : JSON.parse(localStorage.dark)
})

export default vuetify
